import { takeLatest, takeLeading } from "redux-saga/effects";
import {
  refreshCurrentUserData,
  refreshCurrentUserDataStart,
  refreshCurrentUserDataSuccess,
  refreshCurrentUserDataFailure,
  initializeCurrentUserData,
  initializeCurrentUserDataStart,
  initializeCurrentUserDataSuccess,
  initializeCurrentUserDataFailure,
  attemptLogout,
  logoutStart,
  logoutDone,
  attemptLogin,
  loginStart,
  loginSuccess,
  loginFailure,
} from "@/store/slices/auth";
import { fetcherForSagas } from "@/store/fetcherForSagas";
import { requestSelf, requestLogin, requestLogout } from "@/common/api/requests";

function* auth() {
  yield takeLatest(
    refreshCurrentUserData,
    fetcherForSagas({
      start: refreshCurrentUserDataStart,
      success: ({ data, ...other }: any) =>
        refreshCurrentUserDataSuccess({ data, ...other }),
      failure: refreshCurrentUserDataFailure,
      request: () => requestSelf(),
    })
  );
  yield takeLatest(
    [loginSuccess, initializeCurrentUserData],
    fetcherForSagas({
      start: initializeCurrentUserDataStart,
      success: (payload: any) => initializeCurrentUserDataSuccess(payload),
      failure: initializeCurrentUserDataFailure,
      request: () => requestSelf(),
    })
  );
  yield takeLeading(
    // takes first to avoid potential loop of logouts
    attemptLogout,
    fetcherForSagas({
      start: logoutStart,
      // Same logout action for success and failure because BE
      // may return a 4xx if the user is already logged out.
      success: logoutDone,
      failure: logoutDone,
      request: (logOutParams: any) => requestLogout(logOutParams),
    })
  );
  yield takeLatest(
    attemptLogin,
    fetcherForSagas({
      start: loginStart,
      success: loginSuccess,
      failure: loginFailure,
      request: ({ payload }: any) => requestLogin(payload),
    })
  );
}

export default auth;
